export class DriverRankingAppliedPenaltyEntity {
  driverPenaltyId?: string | null
  effectType?: string | null
  effectValue?: number | null
}
